module.exports = __webpack_public_path__ + "img/bagel-de-pina.7f1b73ca.jpg";